import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { Box, Typography, TextField } from "@mui/material";

// Shared react-datepicker wrapper styled to match the app's MUI fields (height
// 38, rounded corners) so pages don't each hand-roll a TextField customInput.
function AppDatePicker({
  label,
  error = false,
  helperText,
  placeholder = "Select date",
  minWidth,
  width,
  ...rest
}) {
  return (
    <Box sx={{ minWidth, width, "& .react-datepicker-wrapper": { width: "100%" } }}>
      {label && (
        <Typography sx={{ fontSize: 13, fontWeight: 700, color: "text.primary", mb: 0.8 }}>
          {label}
        </Typography>
      )}

      <DatePicker
        dateFormat="yyyy-MM-dd"
        placeholderText={placeholder}
        popperProps={{ strategy: "fixed" }}
        customInput={
          <TextField
            fullWidth
            size="small"
            error={error}
            helperText={helperText}
            sx={{
              "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "background.paper" },
              "& .MuiInputBase-input": { height: "1.4375em" },
              "& .MuiFormHelperText-root": { minHeight: 0, mt: helperText ? 0.7 : 0 },
            }}
          />
        }
        {...rest}
      />
    </Box>
  );
}

export default AppDatePicker;
